export default "__VITE_PUBLIC_ASSET__7b34c148__"